<template>
  <main class="l-main">
    <div class="l-error c-card">
      <div class="l-error__inner-red">
        <div class="l-error__message l-error__message--gray">
          <span
            ><Icon name="information_attention" color="#F6AA00" width="31" height="28"
          /></span>
          <p>
            以下の理由でご利用いただけません。
            <br />
            ・契約が存在しない
            <br />
            ・利用期間外（契約開始前/契約終了）
            <br />
            ・アクティベーションキー有効期限切れ
          </p>
        </div>

        <div class="l-error__message" style="color: gray;">
          <p>ブラウザの「×」(閉じる)ボタンで閉じてください。</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  mounted() {
    this.$meta.setDocumentTitle("以下の理由でご利用いただけません。");
    this.$page.isBreadcrumb = false;
    this.$page.isPageHeader = false;
    this.$page.isPageTop = false;
    this.$page.isSubHeader = true;
    this.$page.showFooterMenu = false;
    this.$page.isFooterText = false;
  },
  watch: {
    $route() {
      this.$meta.setDocumentTitle("以下の理由でご利用いただけません。");
      this.$page.isBreadcrumb = false;
      this.$page.isPageHeader = false;
      this.$page.isPageTop = false;
      this.$page.isSubHeader = true;
      this.$page.showFooterMenu = false;
      this.$page.isFooterText = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./l-error.scss";
@import "./l-main.scss";
  .l-error__message {
    svg {
      margin: 0 auto;
    }
  }
</style>
